import { render, staticRenderFns } from "./RectangleV2Icon.vue?vue&type=template&id=6ad391e4&"
import script from "./RectangleV2Icon.vue?vue&type=script&lang=js&"
export * from "./RectangleV2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports